// TODO(jes): yarn tsc:strict complains about a component that will be replaced
import { Spacing } from '@persona-id/design-tokens';
import { Control, Controller } from 'react-hook-form';
import styled from 'styled-components';

import MultiSelect, { useLabelTextMapper } from 'dashboard/components-lib/MultiSelect';
import { GraphNodeConfigFormData } from 'dashboard/forms/FormGraphNodeConfiguration/FormGraphNodeConfiguration';
import { GraphDatumType } from 'dashboard/models/graph-datum-type';
import Card from 'design-system/components/Card';
import { Label } from 'design-system/components/FormControl';

interface EmailSimilarityConfigurationTabProps {
  datumType?: GraphDatumType;
  control: Control<GraphNodeConfigFormData, object>;
}

const StyledMultiSelect = styled(MultiSelect)`
  margin: ${Spacing[2]} 0;
`;

const CRITERIA_OPTIONS = [
  {
    label: 'Alphabetic Character Equivalence',
    value: 'alphabetic-equivalence',
  },
  {
    label: 'Email Domain',
    value: 'domain',
  },
  {
    label: 'Levenshtein Edit Distance 1',
    value: 'edit-distance-1',
  },
  {
    label: 'Levenshtein Edit Distance 2',
    value: 'edit-distance-2',
  },
];

const EmailSimilarityConfigurationTab = ({
  control,
  datumType,
}: EmailSimilarityConfigurationTabProps) => {
  const criteriaLabelTextMapper = useLabelTextMapper(CRITERIA_OPTIONS, 'Criteria', {
    emptyIsAll: false,
  });
  return (
    <Card>
      <Card.Body>
        <Label>When match equals criteria, create a new node:</Label>
        <Controller
          control={control}
          name='graphDatumType.attributes.criteria.rules'
          defaultValue={datumType?.attributes?.criteria?.rules}
          rules={{ required: true }}
          render={({ field: { onChange, value } }) => (
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            <StyledMultiSelect
              labelTextMapper={criteriaLabelTextMapper}
              selectOptionValues={CRITERIA_OPTIONS}
              value={value}
              onChange={onChange}
              disabled={!!datumType?.attributes?.criteria}
            ></StyledMultiSelect>
          )}
        />
      </Card.Body>
    </Card>
  );
};

export default EmailSimilarityConfigurationTab;
